export default __webpack_public_path__ + "static/media/04.7b510ba1.svg";